const Backbone = require('backbone');
import { AppActions } from './actions/AppActions';

import { config } from './config';
import { IGlob } from './Glob';
import { IErrorMessage } from './Interfaces';

class InitialRouter extends Backbone.Router {
    routes() {
        return {
            'ResetPW/:email/:token': 'resetPassword',
            'NewUser/:email/:token': 'setPassword',
            'ApproveDevice/:email/:token': 'approveNewDevice',
            'auth/:token': 'authWithToken',
            'authfailed/:errormessage': 'authFailed',
            'error/:errormessage': 'showError',
            '*default': 'default'
        };
    }

    approveNewDevice(email, token) {
        this.AppActions.approveNewDeviceStart(token);
    }

    resetPassword(email, token) {
        this.AppActions.passwordResetStart(email, token, false);
    }

    setPassword(email, token) {
        this.AppActions.passwordResetStart(email, token, true);
    }

    authWithToken(token) {
        this.AppActions.initialLoad(atob(token));
    }

    authFailed(errormessage) {
        this.AppActions.initialLoad('authFailed:' + atob(errormessage));
    }

    showError(errormessage): void {
        const errorobj: IErrorMessage = JSON.parse(atob(errormessage));
        this.AppActions.showErrorForm(errorobj);
    }

    default() {
        this.AppActions.initialLoad(config.AUTH_TOKEN_OVERRIDE);
    }

    constructor(public glob: IGlob, public AppActions: AppActions, extender) {
        super();

        if (typeof extender === 'function') {
            extender(this);
        }
    }
}

export function get(glob, AppActions, extender?) {
    var res: any = new InitialRouter(glob, AppActions, extender);

    return res;
}
